import axios from 'axios';

import { getAPIUrl } from './baseAPI';
import { Environment } from 'util/environment';

export interface DebugInfo {
  backendEnv: Environment;
  databaseEnv: 'string';
}

export const FETCH_DEBUG_INFO = () => ({
  path: '/debugInfo',
  version: 'v1' as const,
});

export async function fetchDebugInfo() {
  return (await axios.get<DebugInfo>(getAPIUrl(FETCH_DEBUG_INFO()))).data;
}
